import {useMemo} from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import {useTranslation} from 'react-i18next';
import useCurrentPractitioner from '@/practitioner/hooks/useCurrentPractitioner';
import {COMPANY_DETAIL, PATHOLOGY_CUSTOMIZATION_LIST} from '@/practitioner/routing/paths';
import {
  useCompanies,
  useCompany,
  useUserContext
} from '@/shared/contexts/UserContext/useUserContext';

export default function useExtraUserMenuItems() {
  const {t} = useTranslation(['shared/common']);
  const practitioner = useCurrentPractitioner();
  const companies = useCompanies();
  const company = useCompany();
  const {setCompany} = useUserContext();
  return useMemo(
    () =>
      practitioner.practitionerPermissions.administerCompany
        ? [
            {
              to: COMPANY_DETAIL,
              icon: <BusinessIcon fontSize="small" />,
              label: t('shared/common:medicalCenter')
            },
            ...(companies.length > 0
              ? [
                  {
                    onClick: () => setCompany(null),
                    icon: <ChangeCircleIcon fontSize="small" />,
                    label: t('shared/common:changeCompany')
                  }
                ]
              : []),
            ...(company.isForClinicalTrials
              ? []
              : [
                  {
                    to: PATHOLOGY_CUSTOMIZATION_LIST,
                    icon: <AssignmentIcon fontSize="small" />,
                    label: t('shared/common:pathologies')
                  }
                ])
          ]
        : [],
    [t, practitioner, companies, company.isForClinicalTrials, setCompany]
  );
}
